var Base = require('_js/base'),
  $ = require('jquery');

function HeaderSubViewModel() {
  this.$header = $('.sub-header');
  this.init();
}

HeaderSubViewModel.prototype = new Base();

HeaderSubViewModel.prototype.init = function() {
  if ($(document).width() > 1024) {
    $(document).on(
      'scroll',
      function() {
        if ($(document).scrollTop() > 100) {
          this.$header.addClass('reduced');
        } else {
          this.$header.removeClass('reduced');
        }
      }.bind(this)
    );
  }
};

module.exports = HeaderSubViewModel;
